/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import * as types from '../constants/ActionTypes';

const getInitialState = () => ({
  data: null,
  isLoading: false,
  error: null,
  logs: null,
});

const initialState = getInitialState();

const parseSampleAppData = data => [
  {
    name: data.entity.name,
    route: data.entity.appUrl,
    sourceCode: data.entity.repositoryUrl,
    appGuid: data.entity.appGuid,
    // state: "test",
    // actions: "test"
  },
];
const sampleAppData = (state = initialState, action) => {
  switch (action.type) {
    case types.LOAD_SAMPLE_APP_DETAILS_FAILURE:
      return { ...state, error: action.error, isLoading: false };

    case types.LOAD_SAMPLE_APP_DETAILS_SUCCESS: {
      const dataSample = parseSampleAppData(action.data);

      return { ...state, data: dataSample, isLoading: false };
    }

    case types.LOAD_SAMPLE_APP_DETAILS_REQUEST:
      return { ...state, isLoading: true };

    case types.LOAD_STARTER_APP_LOGS_REQUEST:
      return { ...state, logs: null };

    case types.LOAD_STARTER_APP_LOGS_SUCCESS:
      return { ...state, logs: action.data.logMessages };

    case types.LOAD_STARTER_APP_LOGS_FAILURE: {
      return { ...state, logs: action.data };
    }

    default:
      return state;
  }
};

export default sampleAppData;
